import en from "./lang.en";

export default {
	en,
	"en-US": en,
};
